import type { FC } from 'react';

type Props = {
  fillColor?: string;
  strokeWidth?: number;
  strokeColor?: string;
  className?: string;
  label?: string;
};

export const FullStarIcon: FC<Props> = ({
  fillColor = '#ffc346',
  className = 'w-4 h-4',
  strokeColor,
  strokeWidth,
  label
}) => {
  return (
    <svg
      width="36"
      height="34"
      viewBox="0 0 36 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={label}
    >
      <path
        d="M9.18015 32.2026C8.42359 32.659 7.49022 31.9818 7.68935 31.121L9.60291 22.8485C9.85333 21.7659 9.48485 20.6336 8.64528 19.9057L2.22501 14.3395C1.55749 13.7607 1.91343 12.6641 2.7936 12.5877L11.2862 11.8504C12.3938 11.7543 13.3573 11.0536 13.7901 10.0296L17.0789 2.24813C17.423 1.43386 18.577 1.43386 18.9211 2.24813L22.2099 10.0296C22.6427 11.0536 23.6062 11.7543 24.7138 11.8504L33.2064 12.5877C34.0866 12.6641 34.4425 13.7607 33.775 14.3395L27.3547 19.9057C26.5151 20.6336 26.1467 21.7659 26.3971 22.8485L28.3107 31.121C28.5098 31.9818 27.5764 32.659 26.8198 32.2026L19.5496 27.8169C18.5965 27.242 17.4035 27.242 16.4504 27.8169L9.18015 32.2026Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill={fillColor}
      />
    </svg>
  );
};
